<template>
  <div :class="'pagination-' + type" v-if="totalPage>1">
    <li v-if="type=='min' && currentPage != 1" @click="turn(1)">首页</li>
    <li class="prev" v-if="currentPage != 1" :class="{'disabled':currentPage<=1}" @click="currentPage<=1?'':turn(currentPage-1)">
      <img v-if="type=='normal'" src="https://static.soyoung.com/sy-pre/left-1608786600721.png"/>
      <span v-else>上一页</span>
    </li>
    <li v-for="(i,index) in showPageBtn" :key="index" class="num" :class="{'active':i==currentPage}" @click="turn(i)">
      <span v-if="i>0" >{{i}}</span>
      <span v-else-if="i==='-'">...</span>
      <span v-else-if="i==='+'">...</span>
    </li>
    <li class="next" v-if="currentPage != totalPage" :class="{'disabled':currentPage>=totalPage}"  @click="currentPage>=totalPage?'':turn(currentPage+1)">
      <img v-if="type=='normal'" src="https://static.soyoung.com/sy-pre/right-1608786600721.png"/>
      <span v-else>下一页</span>
    </li>
    <li v-if="type=='min' && currentPage != totalPage" @click="turn(totalPage)">尾页</li>
  </div>
</template>
<script lang="ts">
import { defineComponent,computed } from "vue";

export default defineComponent({
  props: {
    currentPage: {//当前页
      type: Number,
      default: 1,
    },
    limit:{//每页显示条数
      type: Number,
      default: 15,
    },
    totalCount:{//总条数
      type: Number,
      default: 0,
      required: true
    },
    type:{//每页显示条数
      type: String,
      default: "normal",
    },
  },
  data(){
    return {
      goPage:'',
      limitNum:0,
      limitNums:[5,10,15,20,25,30],
      toPrev:false,
      toNext:false,
    }
  },
  
  methods: {
    turn(e: any){
      let i = e;
      if(i<1){
        i=1;
      }else if(i > this.totalPage){
        i = this.totalPage;
      }
      this.$emit("turn", i);
    }
  },
  setup(props) {
    const totalPage = computed(() => {
      return Math.ceil(props.totalCount / props.limit);
    });
    const showPageBtn = computed(() => {
      const pageNum = totalPage.value,
        index = props.currentPage,
        arr = [];
      if (pageNum <= 9) {
        for(let i = 1; i <= pageNum; i++) {
          arr.push(i)
        }
        return arr
      }
      if (index < 5) return [1,2,3,4,5,6,7,'+',pageNum]
      if (index >= pageNum -1) return [1,2,'-', pageNum -5,pageNum -4,pageNum -3, pageNum -2, pageNum -1, pageNum]
      if (index === pageNum -2) return [1,2,'-', pageNum -5,pageNum -4,pageNum-3, pageNum-2, pageNum-1, pageNum]
      return [1,'-', index-2,index-1, index, index + 1,index + 2, '+', pageNum]
    })
    return {
      totalPage,
      showPageBtn,
    };
  },
  created(){
    this.limitNum=this.limit;
    if (!this.limitNums.includes(this.limit)) {
      this.limitNums.push(this.limit);
      this.limitNums.sort(function (a: any, b: any) {
        return a-b;
      });
    }
  }
});
</script>
<style lang="less" scoped>
.pagination-normal{
  margin-top: 30px;
  margin-bottom: 60px;
  text-align: center;
  li{
    display: inline-block;
    border: 1px solid #DEDEDE;
    border-radius: 4px;
    width: 40px;
    height: 40px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #777777;
    margin: 0 5px;
    cursor: pointer;
    vertical-align: middle;
    img, span{
      margin-top: 10px;
      line-height: 40px;
    }
  }
  .active{
    background: #73DACF;
    border: 1px solid #73DACF;
    color: #FFFFFF;
  }
}
.pagination-min{
  text-align: right;
  padding: 10px;
  li{
    display: inline-block;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #777777;
    padding: 0 5px;
    cursor: pointer;
    &.active{
      cursor: auto;
      color: #0EC4AF;
    }
  }
}
</style>
